import { render, staticRenderFns } from "./WsDemo.vue?vue&type=template&id=4c5816f4&scoped=true"
import script from "./WsDemo.vue?vue&type=script&lang=js"
export * from "./WsDemo.vue?vue&type=script&lang=js"
import style0 from "./WsDemo.vue?vue&type=style&index=0&id=4c5816f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5816f4",
  null
  
)

export default component.exports